var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Ver Detalle Configuración Base" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("ConfigurarCertificadoForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex === _vm.pasos.configurarCertificado.step,
                expression:
                  "pasoActivoIndex === pasos.configurarCertificado.step"
              }
            ],
            attrs: {
              certificadoSeleccionado: _vm.certificadoSeleccionado,
              modoVer: true
            },
            on: {
              change: _vm.handleFormChange,
              handleFormChange: _vm.handleFormChange,
              handleLogoTercero: _vm.handleLogoChange
            }
          }),
          _vm.pasoActivoIndex === _vm.pasos.editarTexto.step
            ? _c("ConfigurarCertificadoFormTexto", {
                attrs: {
                  certificadoSeleccionado: _vm.certificadoSeleccionado,
                  modoVer: true
                },
                on: {
                  handleTexto: _vm.handleTextoChange,
                  handleFormTextoChange: _vm.handleFormTextoChange
                }
              })
            : _vm._e(),
          _vm.pasoActivoIndex === _vm.pasos.gpsVehiculo.step
            ? _c("ConfigurarCertificadoFormGps", {
                attrs: {
                  certificadoSeleccionado: _vm.certificadoSeleccionado,
                  modoVer: true
                },
                on: { handleFormGps: _vm.handleFormGps }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }